import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { AuthService } from '../../shared/auth/auth.service';
import { GymInfo } from '../../_models/_firebaseObjects/GymInfo';
import { AngularFireDatabase } from 'angularfire2/database';
import { ActivatedRoute, ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import UserCredential = firebase.auth.UserCredential;
import { NgForm } from '@angular/forms';
import { map } from 'rxjs/operators';
import { UserModel } from '../../_models/_firebaseObjects/UserModel';
import { init } from 'ityped'

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.scss']
})
export class SignInComponent implements OnInit, AfterViewInit {
  public allGyms: GymInfo[] = [];
  @ViewChild('signinForm') signInForm: NgForm;
  gymImage: File;
  isRedirectedAfterLoggingOut: Observable<boolean>;
  isRedirectedAfterVerificationFail: Observable<boolean>;
  route: ActivatedRouteSnapshot;
  showSignUpComponent: false;
  signUpError = false;
  message = '';

  formData = {
    email: '',
    password: ''
  }

  constructor(
    private authService: AuthService,
    private db: AngularFireDatabase,
    private router: Router,
    private activatedRoute: ActivatedRoute) {
  }

  ngOnInit() {
    this.isRedirectedAfterLoggingOut = this.activatedRoute.queryParamMap.pipe(
      map(param => param.get('signedout') === 'true')
    );
    this.isRedirectedAfterVerificationFail = this.activatedRoute.queryParamMap.pipe(
      map(param => param.get('verified') === 'false')
    );

    console.log(this.isRedirectedAfterLoggingOut);
    this.db.list('/gyms').valueChanges().subscribe((gymInfoArray: GymInfo[]) => {
      this.allGyms = gymInfoArray;
    });
  }

  ngAfterViewInit() {
    init('#ityped', {
      showCursor: false,
      strings: [
        'classes',
        'challenges',
        'engagement',
        'retention',
        'upsell',
        'feedback',
        'members'
      ],
      typeSpeed:  80,
      backSpeed:  50,
      startDelay: 500,
      backDelay:  4000
    });
  }

  onSubmit() {
    const email = this.formData.email;
    const password = this.formData.password;

    this.authService.signInUser(email, password).then((data: UserCredential) => {
      this.signUpError = false;
      localStorage.setItem('user_uid', data.user.uid);
      const userDetails = this.db.object('users/' + data.user.uid).valueChanges().subscribe((user: UserModel) => {
        if (user && user.role === 'rootAdmin') {
          // this.authService.getUserKey();
          console.log('user is root admin');
          this.removeItemsFromLocalStorage();
          this.navigateToRootAdminPage(data);
        } else {
          this.removeItemsFromLocalStorage();
          this.navigateToGymOwnerPage(data);
        }
      });
      // for root level admins who can see data for all gyms
    }, reason => this.signUpError = true);
  }


  navigateToRootAdminPage(data: UserCredential) {
    localStorage.setItem('auth_token', data.user.refreshToken);
    this.router.navigate(['admin', 'auth', 'dashboard']);
  }

  removeItemsFromLocalStorage() {
    localStorage.removeItem('auth_token');
    localStorage.removeItem('gym_uid');
    localStorage.removeItem('gym_id');
    localStorage.removeItem('gym_name');
    localStorage.removeItem('person_name');
    localStorage.removeItem('gym_logo');
  }

  navigateToGymOwnerPage(data: UserCredential) {
    const getGym = this.db.object('gyms/' + data.user.uid).valueChanges();
    if (getGym) {
      console.log('getGym: ');
      console.log(getGym);
      getGym.subscribe((gymInfo: any) => {
        if (gymInfo.active) {
          console.log(gymInfo);
          localStorage.setItem('gym_uid', data.user.uid);
          localStorage.setItem('gym_id', gymInfo.gymID);
          localStorage.setItem('gym_name', gymInfo['Gym Name']);
          localStorage.setItem('person_name', gymInfo['personName']);
          localStorage.setItem('gym_logo', gymInfo['logoURL']);

          localStorage.setItem('auth_token', data.user.refreshToken);
          this.router.navigate(['gym-owners', 'auth', 'user-board', 'featured-events']);
        } else {
          console.log('you have not been approved by the admin yet');
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/sign-in/sign-in.component.ts